class ManageChoiceCategorySectionButtons {
    constructor() {
        this.choiceCategorySection = document.getElementById('choice-category');
        this.goToButtons           = this.choiceCategorySection.querySelectorAll('.goto');
        this.mySwiper              = document.querySelector('.swiper-container').swiper;

        this.goto();
    }

    goto() {
        for (let i = 0; i < this.goToButtons.length; i++) {
            this.goToButtons[i].addEventListener('click', (e) => {
                e.preventDefault();
                this.mySwiper.slideTo(i + 2, 500, false);
            });
        }
    };
}